import * as angular from "angular";
import { ConstantItems, getDefaultConfig } from "../../constants";
import * as _ from "lodash";
import { ReportDetails } from "../portfolioadmin/reportManagement/models/reportDetails";

export class ReportsRepo {
  static $inject = ["$http", "config"];

  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems
  ) {}

  getReportTypes() {
    return this.$http.get(`${this.config.reportsUrl}/reporttypes`);
  }

  getClientReportByType(clientNumber: string, reportType: string) {
    return this.$http
      .get(`${this.config.reportsUrl}/${clientNumber}/${reportType}`)
      .then((resp) => resp.data as ReportDetails[]);
  }

  getCombinedReportsForUser(reportType: string) {
    return this.$http.get(`${this.config.reportsUrl}/users/${reportType}`);
  }

  sendReportEmails(reportId: number) {
    return this.$http.put(`${this.config.reportsUrl}/${reportId}`, {});
  }

  sendReportEmailToSpecificClients(reportId: number, emailIds: number[]) {
    return this.$http.put(
      `${this.config.reportsUrl}/${reportId}/email`,
      emailIds
    );
  }

  toggleReportLock(reportIds: number[], lockReport: boolean) {
    return this.$http.patch(`${this.config.reportsUrl}/togglelock`, {
      reportIds,
      lock: lockReport,
    });
  }

  uploadCustodianReport = (groupEmailRequest: FormData) => {
    return this.$http.post(
      `${this.config.reportsUrl}/custodians`,
      groupEmailRequest,
      {
        headers: {
          "Content-Type": undefined,
        },
        transformRequest: angular.identity,
      }
    );
  };

  deleteCustodianReport = (id: number) => {
    return this.$http.delete(
      `${this.config.reportsUrl}/custodians/reports/${id}`
    );
  };

  deleteClientReport = (id: number) => {
    return this.$http.delete(
      `${this.config.reportsUrl}/client/reports/${id}`
    );
  };

  getInceptionPerformance(portfolioIds?: Array<number>, date?: string) {
    let queryParams = {
      portfolioIds: portfolioIds,
      date: date,
    };

    let config = getDefaultConfig();
    config.params = queryParams;

    return this.$http.get(
      `${this.config.portfolioUrl}/performance/inception`,
      config
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.repo.ts